import CallLogs from './callLogs';

export default CallLogs;